import React from 'react';
import { useFeatureFlag } from '@moda/portal-stanchions';
import { PasswordCheckoutAuthentication } from './PasswordCheckoutAuthentication';
import { PasswordlessCheckoutAuthentication } from './PasswordlessCheckoutAuthentication';

export const CheckoutAuthentication: React.FC = () => {
  const passwordlessEnabled = useFeatureFlag('passwordless-login', [
    { default: false },
    { if: true, then: true }
  ]);

  if (!passwordlessEnabled) {
    return <PasswordCheckoutAuthentication />;
  }

  return <PasswordlessCheckoutAuthentication />;
};
